import React from 'react';
import { Hero } from './components/Hero';
import { Mission } from './components/Mission';
import { Features } from './components/Features';
import { FeaturedBuilds } from './components/FeaturedBuilds';
import { JoinCTA } from './components/JoinCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-garage-bg text-garage-text selection:bg-garage-accent selection:text-black" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Mission data-id="element-3" />
        <Features data-id="element-4" />
        <FeaturedBuilds data-id="element-5" />
        <JoinCTA data-id="element-6" />
      </main>
      <Footer data-id="element-7" />
    </div>;
}